import { TemplateMacroTable } from './table'
import React, { useState } from 'react'
import { MacroItem, TemplateMacroProps } from '../interface'
import { TemplateMacroToolbar } from './toolbar'
import { message, Modal } from 'antd'
import { getFormatMessage } from '@/utils/utils'
import { TemplateMacroEdit } from './edit'

export const TemplateMacro: React.FC<TemplateMacroProps> = (
  props: TemplateMacroProps
) => {
  const { onDelete } = props
  const [editVisible, setEditVisible] = useState<boolean>(false)
  const [editItem, setEditItem] = useState<MacroItem>()
  const [editResult, setEditResult] = useState<boolean>(false)
  const [saving, setSaving] = useState<boolean>(false)
  const [selected, setSelected] = useState<MacroItem[]>([])
  const formatMessage = getFormatMessage()

  const handleCreate = () => {
    setEditVisible(true)
    setEditItem({ schedules: [{ mode: 0 }] })
  }

  const handleEdit = (item: MacroItem) => {
    setEditItem(item)
    setEditVisible(true)
  }

  const hanldeDelete = (item: MacroItem) => {
    onDelete?.([item])
  }

  const handleBatchDelete = async () => {
    if (!selected || selected.length <= 0) {
      return
    }
    const result = await onDelete?.(selected)
    if (result) {
      setSelected([])
    }
  }

  const handleSave = (item: MacroItem, close?: boolean) => {
    const exist = props.data?.find(
      (x) => x.name === item?.name && x.id !== item?.id
    )
    if (exist) {
      message.error(formatMessage({ id: 'app.template.macro.existName' }))
      return
    }
    setSaving(false)
    setEditResult(false)
    props.onStop?.()
    if (close) {
      props.onClear?.()
      setEditVisible(false)
    } else {
      setEditItem(item)
    }
    props.onSave?.(item)
  }

  const handleItemChange = (item: MacroItem) => {
    setEditItem(item)
    setSaving(true)
  }

  const handleStateChange = (state: boolean) => {
    setSaving(state)
  }

  const hanldeEditModalCancel = (): boolean => {
    props.onStop?.()
    props.onClear?.()
    if (!saving) {
      setEditVisible(false)
      return true
    }
    Modal.confirm({
      title: formatMessage({ id: 'app.modal.title' }),
      content: formatMessage({ id: 'app.template.macro.edit.save.message' }),
      okText: formatMessage({ id: 'app.modal.save' }),
      cancelText: formatMessage({ id: 'app.modal.abandon' }),
      onCancel() {
        setSaving(false)
        setEditVisible(false)
      },
      onOk() {
        setEditResult(true)
      }
    })
    return false
  }

  return (
    <div>
      <TemplateMacroToolbar
        {...props}
        selectable={selected.length > 0}
        onCreate={handleCreate}
        onBatchDelete={handleBatchDelete}
      />
      <TemplateMacroTable
        {...props}
        selectable
        selectionType='checkbox'
        onEdit={handleEdit}
        onDelete={hanldeDelete}
        onSelect={setSelected}
      />
      <Modal
        visible={editVisible}
        onCancel={hanldeEditModalCancel}
        title={
          editItem?.id
            ? formatMessage({
                id: 'app.template.macro.edit.title',
                parameters: { name: editItem.name }
              })
            : formatMessage({ id: 'app.template.macro.toolbar.create' })
        }
        width={1000}
        okText={formatMessage({ id: 'app.modal.ok' })}
        cancelText={formatMessage({ id: 'app.modal.cancel' })}
        maskClosable={false}
        destroyOnClose={true}
        footer={null}
      >
        <TemplateMacroEdit
          {...props}
          formResult={editResult}
          item={editItem}
          saving={saving}
          onSave={handleSave}
          onItemChange={handleItemChange}
          onStateChange={handleStateChange}
        />
      </Modal>
    </div>
  )
}
